import * as React from "react";
import CGReactApplication from "./cgreact-application";
import CGReactComponent from "./cgreact-component";
import LayuiModalStyle from "./cgreact-modal.css";
import {generateUUID} from "./cgreact-util";
import {ModalProp, ModalState} from "../types/cgreact-type-modal";

/** CGReact模态框*/
export default class CGReactModal extends React.Component<ModalProp, ModalState>
{
    /**  React的Context技术实现实现子组件的this.context为AppContext*/
    public static contextType = CGReactApplication.ApplicationContext;
    /** CGReact组件类型*/
    public static CGReactModuleType = "CGReactModal";
    public static CGReactModuleHash;
    /** 通过React的ContextProvider机制提供Modal的引用*/
    public static ModalContext = React.createContext<CGReactModal>(undefined);
    /** 上下文对象*/
    public hash: string;
    public class: typeof CGReactModal;
    public context: CGReactApplication;
    public component: CGReactComponent; //父CGReactComponent对象
    /** 模态框数据结构*/
    public readonly state: ModalState;
    public visible: boolean = false;
    /**页面引用元素 */
    public ModalRef = React.createRef<HTMLDivElement>(); //模态框div元素引用
    public ContentRef = React.createRef<HTMLDivElement>();

    constructor(prop)
    {
        super(prop);
        //初始化实例上下文
        this.class = this.constructor as typeof CGReactModal;
        this.class.CGReactModuleHash = generateUUID();
        // 如果是CGReactComponent集成的Modal则获得这个组件的引用
        this.component = prop.component;
        /** 构造并初始化State*/
        let propState = typeof prop.modal == "object" ? prop.modal : {};
        this.state = {
            title: propState.title,
            content: typeof propState.content == "string" ? <span>{propState.content}</span> : propState.content,
            cancel: propState.cancel ? propState.cancel == true ? "取消" : propState.cancel : undefined,
            confirm: propState.confirm ? propState.confirm == true ? "确定" : propState.confirm : undefined,
            onCancel: () =>
            {
                propState.onCancel && propState.onCancel(); //调用用户通过配置modal传入的回调
                prop.component && prop.component.onModalComponentConfirm(); //调用绑定组件的回调
            },
            onConfirm: () =>
            {
                propState.onConfirm && propState.onConfirm();
                prop.component && prop.component.onModalComponentCancel(); //调用绑定组件的回调
            }
        };
    }

    render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined
    {
        return this.visible ? <CGReactModal.ModalContext.Provider value={this}>
            {/*渲染对话框*/}
            <div ref={this.ModalRef} className="layui-layer layui-layer-dialog layer-anim-bounceIn" style={{visibility: "hidden"}}>
                {/*渲染对话框标题*/}
                {this.state.title && <div className="layui-layer-title">{this.state.title}</div>}
                {/*渲染对话框关闭按钮*/}
                <div className="layui-layer-setwin" onClick={onCancelButtonClick.bind(this)}>
                    <a className="layui-layer-ico layui-layer-close layui-layer-close1"></a>
                </div>
                {/*对话框拖动区域*/}
                <div className="layui-layer-drag"></div>
                {/*渲染对话框内容*/}
                <div ref={this.ContentRef} className="layui-layer-content">
                    {/*首先渲染配置的元素*/}
                    {this.state.content}
                    {/*然后渲染包裹在标签中的元素*/}
                    {this.props.children}
                    {!this.state.content && !this.props.children && CGReactApplication.makeCGReactLogo("这是CGReact模态框")}
                </div>
                {/*渲染对话框按钮*/}
                {(this.state.cancel || this.state.confirm) && <div className="layui-layer-btn">
                    {this.state.confirm && <a className="layui-layer-btn0" onClick={onConfirmButtonClick.bind(this)}>{this.state.confirm}</a>}
                    {this.state.cancel && <a className="layui-layer-btn1" onClick={onCancelButtonClick.bind(this)}>{this.state.cancel}</a>}
				</div>}
                {/*对话框resize的拖动条*/}
                <span className="layui-layer-resize"></span>
            </div>
            {/*渲染对话框遮罩*/}
            <div className="layui-layer-shade" onClick={onCancelButtonClick.bind(this)}></div>
            {/*如果visible=false则渲染null，如果都不是模态框直接渲染子*/}
        </CGReactModal.ModalContext.Provider> : null;

        function onCancelButtonClick(e)
        {
            this.state.onCancel && this.state.onCancel();
            this.dismiss();
        }

        function onConfirmButtonClick(e)
        {
            this.state.onConfirm && this.state.onConfirm();
            this.dismiss();
        }
    }

    componentDidMount(): void
    {
        this.component && (this.component.modal = this);
        this.context.importAssetsSCSS("CGReactModal", LayuiModalStyle as any, this.context.FrameStyleAnchor);
    }

    componentDidUpdate(prevProps: Readonly<ModalProp>, prevState: Readonly<ModalState>, snapshot?: any): void
    {
        // 如果是CGReactComponent中集成的模态框，则调整交给CGReactComponent
        this.visible && this.autoAdjustModal();
    }

    componentWillUnmount(): void
    {
    }

    /**
     * 此回调针对ModalComponent以及配置了props.modal.cancel时生效
     * 点击模态框取消按钮时回调此次函数
     */
    protected onModalCancelEmit(): void
    {
    }

    /**
     * 此回调针对ModalComponent以及配置了props.modal.confirm时生效
     * 点击模态框确认按钮时回调此次函数
     */
    protected onModalConfirmEmit(): void
    {
        // 触发用户传入的回调
        this.state.onConfirm && this.state.onConfirm();
        // 关闭对话框
        this.dismiss();
    }

    public display(): void
    {
        // 现实并刷新页面
        this.visible = true;
        this.setState({});
    }

    public dismiss(): void
    {
        this.ModalRef.current.className += ' layer-anim-close';
        this.visible = false;
        window.setTimeout(() => this.setState({}), 600);
    }

    public autoAdjustModal()
    {
        /** 调整对话框位置*/
        if (this.ModalRef.current)
        {
            this.ModalRef.current.style.visibility = "visible";
            this.ModalRef.current.style.top = (window.innerHeight - this.ModalRef.current.offsetHeight) / 2 + "px";
            this.ModalRef.current.style.left = (window.innerWidth - this.ModalRef.current.offsetWidth) / 2 + "px";
        } else
        {
            console.error("没有获取到ModalRef的实例");
        }
    }
}
